import React from 'react';

export default function RadioButton(props) {
  const inputProps = {
    type: 'radio',
    id: props.id || 'input-' + props.name + '-' + encodeURI(props.value),
    name: props.name,
    value: props.value || '',
    checked: props.checked,
    onChange: props.onChange,
  }
  return (
    <div className="radio">
      <label>
        <input {...inputProps} />
        {props.label || props.name}
      </label>
    </div>
  );
}



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/ui-react/RadioButton.jsx